import React from "react";
import Link from "react-router-dom";
import Image from "../atoms/Image";
import Config from "../../constants/Config";

const { cmsPrefix } = Config;

const SlideCTA = ({ copy, link }) => {
    return (
        <div
            className={`slide`}
        >
            <div className="slide__container">
                <a className="slide__cta" href={link} target={`_blank`}>
                    <div className={`slide__cta__copy`}>
                        {copy}
                    </div>
                    <div className={`slide__cta__img`}>
                        <Image
                            src={
                                cmsPrefix +
                                "/assets/images/shake-win-right-arrow.svg"
                            }
                        />
                    </div>
                </a>
            </div>
        </div>
    );
};

export default SlideCTA;
